import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-background-50 cursor-pointer">
              superbuy<span className="text-primary-500">.beer</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
              Your trusted resource for Superbuy Spreadsheet guides, verified seller lists, and international shopping tips. Updated regularly for the community.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              Resources
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                Home
              </Link>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                Superbuy Spreadsheet
              </a>
              <Link to="/blog/best-superbuy-spreadsheet-2026" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                Best Spreadsheet 2026
              </Link>
              <a href="#safety" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                Safety Guide
              </a>
              <a href="#faq" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                FAQ
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              Categories
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                Shoes
              </a>
              <a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                Hoodies &amp; Sweaters
              </a>
              <a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                T-Shirts
              </a>
              <a href="https://kaspreadsheet.com/category-914-Jackets.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                Jackets
              </a>
              <a href="https://kaspreadsheet.com/category-917-Sets.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                Sets
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                Buy It Now →
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                Superbuy Spreadsheet →
              </a>
              <Link to="/blog/best-superbuy-spreadsheet-2026" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                Read Our Guide →
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 superbuy.beer — An informational resource. Not affiliated with Superbuy.
          </p>
          <p className="text-xs text-foreground-500">
            Always verify products and sellers before purchasing.
          </p>
        </div>
      </div>

      <div className="overflow-hidden">
        <div className="text-[10vw] md:text-[12vw] font-heading font-black text-foreground-900/15 tracking-tighter leading-none px-4 md:px-6 pb-4 select-none whitespace-nowrap">
          SUPERBUY
        </div>
      </div>
    </footer>
  );
}